import {makeStyles} from "tss-react/mui";

export const useSidebarAgentStyles = makeStyles()(
  (theme, {currentSidebarWidth = 0, panelWidth = 0, agentPanelWidth = 0} = {}) => ({
    toggleWrapper: {
      position: "fixed",
      top: 60,
      left: currentSidebarWidth + agentPanelWidth,
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create("left", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    toggle: {
      width: 34,
      height: 40,
      minWidth: 34,
      borderRadius: "0px 8px 8px 0px",
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      "&:hover": {backgroundColor: theme.palette.primary.dark},
    },
    panel: {
      position: "fixed",
      top: 0,
      left: currentSidebarWidth,
      width: panelWidth,
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      zIndex: theme.zIndex.drawer,
      backgroundColor: theme.palette.background.paper,
      borderRight: `1px solid ${theme.palette.divider}`,
      overflow: "hidden",
    },
    backHeader: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(0.5, 1),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    headerActions: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(0.5),
      marginLeft: "auto",
    },
    contextIcon: {
      marginLeft: theme.spacing(0.5),
      fontSize: "1rem",
      flexShrink: 0,
    },
    sessionListBox: {
      flex: 1,
      overflowY: "auto",
      overscrollBehavior: "contain",
    },
  }),
);
